import { ComponentType } from 'react';

// Components that chat messages can embed with a `$widget:<kind>:<id>` token.
// Feature modules provide them; they are registered from the composition root (src/app).
export type ChatEmbed = ComponentType<{ id: string }>;

const embeds = new Map<string, ChatEmbed>();

export function registerChatEmbed(kind: string, embed: ChatEmbed) {
  embeds.set(kind, embed);
}

export function getChatEmbed(kind: string): ChatEmbed | undefined {
  return embeds.get(kind);
}
